module.exports = __webpack_public_path__ + "static/media/number_one_icon_new.6356652a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/number_one_icon_new.svg
// module id = 248
// module chunks = 0